import {
  isUserWithGroupsResponseDTO,
  UserWithGroupsResponseApi,
} from "../DTO/ServerResponseType/Group/User";
import {
  isUserResponseDTO,
  UserResponseApi,
} from "../DTO/ServerResponseType/User";
import { UserObservableRequestApi } from "../DTO/User";
import { UserRoleEnum } from "../Enums/UserRoles";
import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class UserServerClient {
  private path = "/user";

  sendPasswordResetEmailAsync = async (mail: string): Promise<void> => {
    await ServerClient.sendRequestAsync({
      url: serverOrigin + this.path + "/passwordRecovery/sendLetter",
      method: "POST",
      body: JSON.stringify({ mail }),
      headers: { "Content-Type": "application/json" },
    });
  };

  sendToRegistrateUserAsync = async (
    user: UserObservableRequestApi
  ): Promise<void> => {
    let url: string = serverOrigin + this.path + "/registration";

    await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(user),
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  sendToLoginUserAsync = async (
    user: UserObservableRequestApi
  ): Promise<void> => {
    let url: string = serverOrigin + this.path + "/login";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(user),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    }).then(() => {
      alert("Пользователь успешно вошел.");
    });
  };

  sendToLogoutUserAsync = async (): Promise<void> => {
    let url: string = serverOrigin + this.path + "/logout";

    return await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      credentials: "include",
    }).then(() => {
      alert("Пользователь успешно вышел.");
    });
  };

  sendToGetUserAsync = async (): Promise<UserResponseApi | never> => {
    let url: string = serverOrigin + this.path + "/data";
    return await getTypeGuardedVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "GET",
        credentials: "include",
      }),
      isUserResponseDTO
    ).catch((error) => {
      console.error("Ошибка:", error);
      throw error;
    });
  };

  sendToGetUserWithGroupsAsync = async (): Promise<
    UserWithGroupsResponseApi | never
  > => {
    let url: string =
      serverOrigin +
      this.path +
      "/data" +
      "?withGroups=true&withStudentProgress=true";
    return await getTypeGuardedVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "GET",
        credentials: "include",
      }),
      isUserWithGroupsResponseDTO
    ).catch((error) => {
      console.error("Ошибка:", error);
      throw error;
    });
  };

  sendToGetAllUsersAsync = async (): Promise<UserResponseApi[]> => {
    let url: string = serverOrigin + this.path + "/show/all";
    return await getTypeGuardedArrayVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "GET",
        credentials: "include",
      }),
      isUserResponseDTO
    ).catch((error) => {
      console.error("Ошибка:", error);
      throw error;
    });
  };

  sendToUpdateUserRoleAsync = async (
    userId: string,
    newRoles: UserRoleEnum[]
  ): Promise<null> => {
    await this.sendUpdatedUserRolesAsync(userId, newRoles)
      .then(() => {
        alert(`У пользователя успешно изменены роли`);
        return userId;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
      });

    return null;
  };

  sendUpdatedUserRolesAsync = async (
    userId: string,
    newRoles: UserRoleEnum[]
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/update/roles";
    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        userId: userId,
        newRoles: newRoles,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };
}

let userServerClient = new UserServerClient();

export default userServerClient;
